// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconShareFb: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
            <path
                d="M147.5,1 L136.5,1 C135.671573,1 135,1.67157269 135,2.5 L135,13.5 C135,14.3284273 135.671573,15 136.5,15 L140.789062,15 L140.789062,10.2403126 L138.820312,10.2403126 L138.820312,8 L140.789062,8 L140.789062,6.29250002 C140.789062,4.35031223 141.945312,3.27750015 143.716249,3.27750015 C144.564375,3.27750015 145.451249,3.42875004 145.451249,3.42875004 L145.451249,5.33500004 L144.474062,5.33500004 C143.51125,5.33500004 143.210938,5.93249989 143.210938,6.5453124 L143.210938,8 L145.360312,8 L145.016562,10.2403126 L143.210938,10.2403126 L143.210938,15 L147.5,15 C148.328427,15 149,14.3284273 149,13.5 L149,2.5 C149,1.67157269 148.328427,1 147.5,1 Z"
                transform="translate(-135 -1)"
            />
        </svg>
    );
};

export default React.memo(IconShareFb);
